import UserRestrict from './UserRestrict';

export default UserRestrict;
